import styled from 'styled-components';
import { ReactElement } from 'react';
import RadioIcon from './icon/RadioIcon';

interface Props {
  isSelected: boolean;
  onClick?: () => void;
  content: ReactElement | string;
  gap?: number;
}

/**
 * @required isSelected
 * @required onClick
 * @required content
 * @optional gap default 8
 * @returns
 */

const Radio = ({
  isSelected,
  onClick,
  content,
  gap = 8
}: Props) => {
  return (
    <Row onClick={onClick}>
      <RadioIcon isSelected={isSelected} />
      <Content gap={gap}>{content}</Content>
    </Row>
  );
};

export default Radio;

const Row = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const Content = styled.div<{ gap: number }>`
  display: flex;
  align-items: center;

  ${({ gap }) => `
    margin-left: ${gap}px;
  `};
`;
